export class LoggerCodes {
  /* TODO - CEF 12-14-2018
    public static get HTTP_REQUEST_GET_ERROR(): number { return 100; }
    public static get HTTP_REQUEST_POST_ERROR(): number { return 101; }



    public static get CONTENT_HTTP_ERROR(): number { return 300; }
    public static get CONTENT_JSON_PARSE_ERROR(): number { return 301; }
    public static get CONTENT_MISSING_META(): number { return 302; }

    public static get GATEKEEPER_HTTP_ERROR(): number { return 400; }

    public static get INTERACT_EVENT_ERROR(): number { return 500; }

    public static get YES_NO_SURVEY_VOTE(): number { return 600; }

    public static get ADDRESS_VALIDATION_ZIP_CODE_MATCH_ERROR(): number { return 700; }
    public static get ADDRESS_VALIDATION_CODE_ONE_ERROR(): number { return 701; }
    public static get JOB_TITLE_CHECK_SERVICE_ERROR(): number { return 702; }

    public static get ALL_SUBMIT_RESPONSE_ERRORS(): number { return 801; }
    public static get ERROR_CAUGHT_DURING_SUBMIT_POST(): number { return 802; }

    public static get REVIEW_INFO_SERVICE_ERROR(): number { return 900; }
    public static get REVIEW_CALL_RULES_FAILURE(): number { return 901; }
    public static get REVIEW_CALL_PERFORMANCE():  number { return 907; }

    public static get CODE_ONE_VALIDATION_POST_ERROR(): number { return 1000; }

    public static get HNW_CLEAR_CACHE_ERROR(): number { return 1001; }

    public static get ELIGIBLE_ACCOUNTS_SERVICE_ERROR(): number { return 1100; }

    public static get CLIENT_ID_SERVICE_ERROR(): number { return 1110; }
    */
  public static get SUBMIT_ERROR(): number {
    return 800;
  }

  // public static get SUBMIT_ERROR1(): number {
  //   return 801
  // }

  public static get GENERAL_SUCCESS(): number {
    return 100;
  }

  public static get NULL_FAILURE(): number {
    return 101;
  }

  public static get INVALID_URL(): number {
    return 102;
  }
  // public static get ADOBE_ANALYTICS_MISSING_IMPL(): number {
  //   return 200
  // }

  // public static get ADOBE_ANALYTICS_MISSING_DATA_LAYER(): number {
  //   return 201
  // }
  // public static get ADOBE_ANALYTICS_DATA_LAYER_MALFORMED(): number {
  //   return 202
  // }

  public static get DECEASED_TRUE(): number {
    return 400;
  }

  public static get DECEASED_FALSE(): number {
    return 401;
  }

  public static get DECEASED_NOT_FOUND(): number {
    return 402;
  }

  public static get SECURE_MESSAGE_SUCCESS(): number {
    return 2000;
  }
  public static get SECURE_MESSAGE_FAILURE(): number {
    return 2010;
  }
  public static get SECURE_MESSAGE_INTERNAL_FAILURE(): number {
    return 2011;
  }
  public static get SECURE_MESSAGE_INTERNAL_ADOBE_FAILURE(): number {
    return 2012;
  }
  public static get CLIENT_DATA_PROCESSING_EXCEPTION(): number {
    return 4031;
  }

  public static get CLIENT_ACCOUNT_PROCESSING_EXCEPTION(): number {
    return 4032;
  }

  public static get WINDOW_MESSAGE_PARSE_FAILURE(): number {
    return 5010;
  }
  public static get MEDALLIA_LOAD_SURVEY_FAILURE(): number {
    return 6010;
  }
  public static get BENE_MATCH(): number {
    return 7000;
  }

  public static get COST_BASIS_FAILURE(): number {
    return 8000;
  }

  public static get OBE_DRAFT_EVENT_FAILURE(): number {
    return 8100;
  }

  public static get CONVERT_TO_PDF_FAILURE(): number {
    return 10010;
  }
  // public static get CONVERT_TO_PDF_EMPTY_FILESMETADATA(): number {
  //   return 10011
  // }
  public static get FMF_SERVICE_FAILURE(): number {
    return 999;
  }
}
